import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { apiService } from '../../../../../../service/api.service';
import { ResponseOtrasCuentasModel, OtrasCuentasModel, CuentasModel } from '../../../../../../model/Cuentas.model'
import { MatPaginator, PageEvent} from '@angular/material/paginator';
import { MatSort} from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog'; 
import { ModalFichaUsuarioComponent } from '../../../dialogs/modal-ficha-usuario/modal-ficha-usuario.component';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cuentas-usuario',
  templateUrl: './cuentas-usuario.component.html',
  styleUrls: ['./cuentas-usuario.component.css']
})
export class CuentasUsuarioComponent implements OnInit {
  filterValues = {}; 
  filterSelectObjOtros = []; 
  //displayedColumns=[];
  displayedColumnsOtrasCuentas=[];
  apiEndpoint = environment.apiEndpoint;
  dataSourceOtrasCuentas: MatTableDataSource<OtrasCuentasModel>;
  columnNamesOtrasCuentas = [
    { id: 'region', value: 'region' }, 
    { id: 'estamento', value: 'estamento' }, 
    { id: 'codigoJardin', value: 'codigoJardin' }, 
    { id: 'nombreJardin', value: 'nombreJardin' }, 
    { id: 'nombres', value: 'nombres' }, 
    { id: 'apellidos', value: 'apellidos' }, 
    { id: 'correo', value: 'correo' }, 
    { id: 'usuario', value: 'usuario' }, 
    { id: 'password', value: 'password' }, 
    { id: 'bloqueo', value: 'bloqueo' }, 

  ];


  pageEvent: PageEvent;
  pageIndex:number;
  palabraClave: string;
  idRegion:number;
  idComuna:number;
  idPrograma:number;
  length:number;
  arrayComunas = [];

  
  @ViewChild(MatPaginator, {read: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @Input() infoSelectJardin: CuentasModel;
  constructor(
    private api: apiService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.palabraClave = "";
    this.idRegion = 0;
    this.idComuna = 0;
    this.idPrograma = 0;
    this.getServerData();
  }

  public getServerData(event?:PageEvent){
    this.callData(event != null ? event : null ,null);
  }

  public callData(event?:PageEvent,palabraClave?:string){
    this.spinner.show();
    let pageNum = event != null ? (event.pageIndex + 1) : 1;
    let pageSize = event != null ? event.pageSize : 10;
    this.api.API_POST_getOtrasCuentas(pageNum,pageSize,this.palabraClave,this.idRegion,this.idComuna,this.idPrograma).subscribe((response: ResponseOtrasCuentasModel) => {
      this.displayedColumnsOtrasCuentas = this.columnNamesOtrasCuentas.map(x => x.id);
      this.dataSourceOtrasCuentas = new MatTableDataSource<OtrasCuentasModel>(response.payload.list);
      this.pageIndex = (response.payload.pageNum - 1);
      this.length = response.payload.total;

      setTimeout(() => {
        
        this.dataSourceOtrasCuentas.paginator = this.paginator;
        this.spinner.hide();

      }, 1000);
        
    },
    (err) => {
      console.log("error"+err)
    })
  }


  buscar(palabraClave){
    this.palabraClave = palabraClave;
    this.callData(null);
  }

  crearCuentaUsuario(){
    const dialogRef = this.dialog.open(ModalFichaUsuarioComponent,{
      disableClose: true ,
      width: '50%',
      data: {dataSelects: this.infoSelectJardin} 
    });
  }

  bloquear(row:OtrasCuentasModel, tipo: string){
    this.spinner.show();
    this.api.API_POST_bloquearUsuario(row.id, tipo).subscribe((response: ResponseOtrasCuentasModel) => {
        this.spinner.hide();
    },
    (err) => {
      console.log(err)
      alert(err)
      this.spinner.hide();
    })
  } 

  seleccionarRegion(value){
    this.idRegion = value;
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(value);
    this.arrayComunas = this.infoSelectJardin.regiones[indexRegion].comunas;
    this.callData(null);
  }

  seleccionarComuna(value){
    this.idComuna = value;
    this.callData(null);
  }

  seleccionarPrograma(value){
    this.idPrograma = value;
    this.callData(null);
  }

  nombreRegion(id){
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(id);
    return this.infoSelectJardin.regiones[indexRegion].nombre;
  }

  nombreComuna(idRegion,IdComuna){
    const indexRegion = this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(idRegion);
    const indexComuna = this.infoSelectJardin.regiones[indexRegion].comunas.map(element => element.idComuna).indexOf(IdComuna);
    return this.infoSelectJardin.regiones[indexRegion].comunas[indexComuna].nombre;
  }

}
